<template>
  <div class="ae_wrap">
    <a-form :model="formData">
      <a-form-item :labelCol="{span: 1, offset: 0}"  label="标题">
        <a-input
          style="width: 200px;"
          v-model="formData.title"
        />
      </a-form-item>
      <a-form-item :labelCol="{span: 1, offset: 0}"  label="类型">
        <a-select v-model="formData.type" :default-value="0" style="width: 120px" @change="handleChangeType">
          <a-select-option :value="0">
            文章
          </a-select-option>
          <a-select-option :value="1">
            视频
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="{span: 1, offset: 0}"  label="发布人">
        <a-input
          style="width: 200px;"
          v-model="formData.auther"
        />
      </a-form-item>
      <a-form-item :labelCol="{span: 1, offset: 0}"  label="简介">
        <a-textarea
          style="width: 300px; height: 150px"
          v-model="formData.simpleContent"
          placeholder="请输入简介"
          :auto-size="{ minRows: 2, maxRows: 6 }"
        />
      </a-form-item>
      <a-form-item  :labelCol="{span: 1, offset:0}" :label="formData.type==0?'上传图片':'上传视频'"
                   v-bind="formItemLayout"
      >
        <a-upload
          v-if="formData.type==0"
          :action="serverUrl+'?action=uploadimage'"
          listType="picture-card"
          :fileList="imgs"
          accept=".bmp.jpg,.png"
          :beforeUpload="beforeUpload"
          @change="handleChange"
        >
          <div v-if="imgs.length < 1">
            <a-icon type="plus"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>

        <a-upload v-if="formData.type==1" :action="serverUrl+'?action=uploadimage'"
                  accept="video/*"
                  @change="handleChangeVideo"
                  >
            <div>上传视频</div>
        </a-upload>
      </a-form-item>
      <a-form-item v-if="formData.type==0">
        <vue-ueditor-wrap
          style="width: 1200px"
          v-model="formData.content" :config="config"></vue-ueditor-wrap>
      </a-form-item>
      <a-form-item :labelCol="{span: 1, offset: 0}" >
        <a-button type="primary" @click="handleSubmit">
          确定
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
import config from '../../config/index' // ES6 Module
const residences = [
  {
    value: 'zhejiang',
    label: 'Zhejiang',
    children: [
      {
        value: 'hangzhou',
        label: 'Hangzhou',
        children: [
          {
            value: 'xihu',
            label: 'West Lake',
          },
        ],
      },
    ],
  },
  {
    value: 'jiangsu',
    label: 'Jiangsu',
    children: [
      {
        value: 'nanjing',
        label: 'Nanjing',
        children: [
          {
            value: 'zhonghuamen',
            label: 'Zhong Hua Men',
          },
        ],
      },
    ],
  },
];
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}
export default {
  name: "add-earningHome",
  components: {
    VueUeditorWrap
  },
  data() {
    return {
      serverUrl: config.baseURL + '/ueditor/config',
      loading: false,
      imageUrl: '',
      formData:{
        title:'',
        type:0,
        auther:'',
        simpleContent:'',
        content:'',
        img:'',
        videoUrl:''
      },
      residences,
      formItemLayout: {
        labelCol: {
          xs: { span: 8 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 8 },
          sm: { span: 8 },
        },
      },
      imgs:[],
      config: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: true,
        // 初始容器高度
        initialFrameHeight: 240,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        serverUrl: config.baseURL+'api/greens/upload/img'
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        // UEDITOR_HOME_URL: '/static/UEditor/'
        // 配合最新编译的资源文件，你可以实现添加自定义Request Headers,详情https://github.com/HaoChuan9421/ueditor/commits/dev-1.4.3.3
        // headers: {
        //   access_token: '37e7c9e3fda54cca94b8c88a4b5ddbf3'
        // }
      },
    };
  },
  beforeCreate() {
    let options={
      title:'',
      type:0,
      auther:'',
      simpleContent:''
    }
    this.form = this.$form.createForm(this, options);
  },
  mounted(){

  },
  methods: {
    handleChangeType(e){
      console.log(e)
      if(e==0){this.formData.videoUrl=''}
      else {
        this.formData.img=''
        this.formData.content=''
      }
    },
    handleChange({fileList}) {

      this.imgs = fileList || []
    },
    handleChangeVideo({fileList}) {

      this.formData.videoUrl=fileList?fileList[0].response.url:''
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('请上传jpeg、png格式图片!');
        this.imgs=[]
      }
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isLt2M) {
      //   this.$message.error('Image must smaller than 2MB!');
      //   this.imgs=[]
      // }
      return isJpgOrPng;
    },
    handleSubmit() {

      this.formData.img=this.imgs.length>0?this.imgs[0].response&&this.imgs[0].response.url?this.imgs[0].response.url:'':''
      let data=JSON.parse(JSON.stringify(this.formData))
      if(this.formData.type==0){
        delete data.videoUrl
      }else {
        delete  data.content
        delete  data.img
      }
      let objArr= Object.keys(data)
      for(let i=0;i<objArr.length;i++){
        if(String(this.formData[objArr[i]]).length==0){
          this.$message.warning('请完善信息');
          return
        }
      }
      this.$post('/lzStudy',data).then(res=>{
            this.$router.back()
      })
    },
  }
}
</script>

<style scoped>
  .ae_wrap{
    background: #ffffff;
    padding: 20px 30px;
  }
  /deep/ .ant-col-sm-offset-8{
    margin-left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/learning/add-earningHome.vue